import { useEffect, useState } from "react";
import { MessageCircleMore, Mail } from "lucide-react";
import { getSettings, FALLBACK_SETTINGS } from "../api";
import { useLang } from "../i18n";

export function FloatingContact() {
  const [contact, setContact] = useState(FALLBACK_SETTINGS.contact);
  const { lang } = useLang();
  useEffect(() => {
    getSettings().then((s) => setContact(s.contact));
  }, []);

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-50 flex flex-col items-center gap-2.5 sm:gap-3">
      <a
        href="mailto:pettaxilondon@gmail.com"
        aria-label={lang === "fr" ? "Envoyez-nous un email" : "Email us"}
        data-testid="email-fab"
        className="flex items-center justify-center w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-white text-midnight shadow-xl hover:scale-105 transition-transform"
      >
        <Mail className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>
      <a
        href={`https://wa.me/${contact.whatsapp}?text=${encodeURIComponent("Hi! I need pet transport between London and Europe.")}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={lang === "fr" ? "Chat en direct sur WhatsApp" : "Live chat on WhatsApp"}
        data-testid="live-chat-btn"
        className="relative group block"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" aria-hidden="true" />
        <span className="absolute -inset-1.5 rounded-full border-2 border-[#25D366]/50 animate-pulse" aria-hidden="true" />
        <span className="relative flex items-center gap-1.5 sm:gap-2 rounded-full bg-[#25D366] text-[#0B1F14] pl-3 pr-3.5 sm:pl-4 sm:pr-5 h-11 sm:h-14 shadow-xl shadow-[#25D366]/30 group-hover:scale-105 group-hover:bg-[#1EBE5B] transition-all">
          <MessageCircleMore className="w-5 h-5 sm:w-6 sm:h-6" />
          <span className="font-bold text-xs sm:text-sm whitespace-nowrap">{lang === "fr" ? "Chat en direct" : "Live chat"}</span>
        </span>
      </a>
    </div>
  );
}
